/* src/app/system-utils/authentication-form/authentication-form.component.scss */
:host {
  display: block;
  height: 100%;
}
.login-shell {
  display: flex;
  min-height: 100vh;
  background: #ffffff;
}
.brand-panel {
  flex: 1 1 52%;
  background:
    radial-gradient(
      1200px 600px at 85% -10%,
      rgba(46, 197, 162, 0.14),
      transparent 60%),
    linear-gradient(
      160deg,
      #0e3350 0%,
      #134465 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  overflow: hidden;
}
.brand-panel__inner {
  max-width: 480px;
  width: 100%;
}
.brand-panel__logo {
  max-width: 200px;
  height: auto;
  margin-bottom: 48px;
}
.brand-panel__headline {
  font-size: clamp(1.8rem, 3vw, 2.6rem);
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: #fff;
  margin: 0 0 12px;
}
.brand-panel__sub {
  font-size: 1rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.72);
  margin: 0 0 40px;
  max-width: 380px;
}
.brand-panel__flow {
  width: 100%;
  max-width: 420px;
  display: block;
}
.flow-line {
  stroke: rgba(255, 255, 255, 0.28);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-dasharray: 6 10;
  animation: flow-dash 2.4s linear infinite;
}
.flow-line--slow {
  animation-duration: 3.6s;
}
.flow-line--fast {
  animation-duration: 1.8s;
}
.flow-node circle,
.flow-node rect {
  fill: rgba(255, 255, 255, 0.1);
  stroke: #7fe0c9;
  stroke-width: 2;
}
.flow-node--hub rect {
  fill: rgba(46, 197, 162, 0.22);
  stroke: #2ec5a2;
}
@keyframes flow-dash {
  to {
    stroke-dashoffset: -32;
  }
}
@media (prefers-reduced-motion: reduce) {
  .flow-line {
    animation: none;
  }
}
.form-panel {
  flex: 1 1 48%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px 24px;
}
.form-card {
  width: 100%;
  max-width: 400px;
}
.form-card__header {
  margin-bottom: 28px;
}
.form-card__title {
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #12283a;
  margin: 0 0 6px;
}
.form-card__hint {
  font-size: 0.9rem;
  color: #5b7285;
  margin: 0;
  line-height: 1.5;
}
.login-form ::ng-deep .ant-form-item {
  margin-bottom: 18px;
}
.login-form ::ng-deep .ant-form-item-label > label {
  font-weight: 600;
  color: #12283a;
}
.login-form ::ng-deep .ant-input,
.login-form ::ng-deep .ant-input-affix-wrapper {
  background: #f6f9fb;
  border-color: transparent;
  border-radius: 10px;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}
.login-form ::ng-deep .ant-input {
  padding: 9px 12px;
}
.login-form ::ng-deep .ant-input-affix-wrapper .ant-input {
  background: transparent;
  padding: 5px 0;
}
.login-form ::ng-deep .ant-input-affix-wrapper {
  padding: 4px 12px;
}
.login-form ::ng-deep .ant-input:hover,
.login-form ::ng-deep .ant-input-affix-wrapper:hover {
  background: rgb(238.9384615385, 244.2923076923, 247.8615384615);
  border-color: rgba(19, 68, 101, 0.18);
}
.login-form ::ng-deep .ant-input:focus,
.login-form ::ng-deep .ant-input-focused,
.login-form ::ng-deep .ant-input-affix-wrapper-focused {
  background: #ffffff;
  border-color: #2ec5a2;
  box-shadow: 0 0 0 3px rgba(46, 197, 162, 0.18);
}
.password-toggle {
  cursor: pointer;
  color: #5b7285;
  transition: color 0.2s ease;
}
.password-toggle:hover,
.password-toggle:focus-visible {
  color: #134465;
  outline: none;
}
.mfa-input {
  font-size: 1.25rem;
  letter-spacing: 0.45em;
  text-align: center;
  font-variant-numeric: tabular-nums;
}
.submit-btn {
  margin-top: 6px;
  height: 44px;
  border-radius: 10px;
  font-weight: 600;
  color: #ffffff;
}
.submit-btn.ant-btn-primary {
  background: #134465;
  border-color: #134465;
}
.submit-btn.ant-btn-primary:hover:not([disabled]),
.submit-btn.ant-btn-primary:focus:not([disabled]) {
  background: rgb(23.845, 85.34, 126.755);
  border-color: rgb(23.845, 85.34, 126.755);
}
.resend-btn {
  margin-top: 10px;
  height: 44px;
  border-radius: 10px;
}
.login-alert {
  margin-bottom: 16px;
  border-radius: 10px;
}
.login-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}
.login-actions button {
  padding: 0;
  color: #5b7285;
}
.login-actions button:hover {
  color: #2ec5a2;
}
.form-panel__footer {
  margin-top: auto;
  padding-top: 32px;
  font-size: 0.78rem;
  color: rgb(145.75, 164.6428571429, 180.25);
}
@media only screen and (max-width: 920px) {
  .login-shell {
    flex-direction: column;
  }
  .brand-panel {
    flex: none;
    padding: 20px 24px;
    align-items: flex-start;
  }
  .brand-panel__inner {
    display: flex;
    align-items: center;
    gap: 16px;
    max-width: none;
  }
  .brand-panel__logo {
    max-width: 120px;
    margin-bottom: 0;
  }
  .brand-panel__headline,
  .brand-panel__sub,
  .brand-panel__flow {
    display: none;
  }
  .form-panel {
    flex: 1;
    padding: 32px 20px 16px;
  }
}
/*# sourceMappingURL=authentication-form.component.css.map */
